import { IStoreState, IUpdateDriver } from '../../types'
import { getDriverById } from '../../state/reducers/drivers'
import { getSingleDriver, updateDriverInfo } from '../../state/actions/drivers'
import { connect } from 'react-redux'
import DriverEdit from '../../components/drivers/DriverEdit'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    driver: getDriverById(state, ownProps.driverId),
    loading: state.drivers.isSelectedDriverFetch || state.drivers.processing,
    loadingError: state.drivers.selectedDriverError || state.drivers.processingError,
    routeProps: ownProps.routeProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getDriverInfo: (driverId: string) => dispatch(getSingleDriver(driverId)),
    updateDriverInfo: (driverInfo: IUpdateDriver) => dispatch(updateDriverInfo(driverInfo))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverEdit)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverEdit.ts